<div class="scrollbar-container">
  <div class="top-scrollbar" #topScroll (scroll)="syncScroll(topScroll, scrollEl)">
    <div class="scroll-content" #scrollContent></div>
  </div>
</div>
